
import { defineComponent } from "vue";
import { store } from "@/store";

export default defineComponent({
  components: {},
  props: {
    processId: {
      type: String,
      required: true,
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      name: "",
    };
  },
  computed: {
    type: function () {
      return store.getters["settingsProcesses/getSubTypes"].find((t: any) => t.processId === this.processId)
    },
  },
  watch: {
    type: function () {
      this.name = '';
    }
  },
  mounted() {
    this.name = "";
  },
  methods: {
    submit: async function () {
      this.submitted = true;

      store.dispatch("settingsProcesses/cloneSubProcess", { name: this.name, processId: this.processId });

      this.submitted = false;
      const el = this.$refs["closeBtn"] as any;

      el.click();
      this.$emit("reload");
    },
  },
});
